var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroups2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13.996,
    viewBox: "0 0 14 13.996",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(255.5 -236.505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-245.452,239.443a1.817,1.817,0,0,0,.313-1.032,1.9,1.9,0,0,0-1.906-1.906,1.9,1.9,0,0,0-1.906,1.906,1.9,1.9,0,0,0,1.906,1.906,1.861,1.861,0,0,0,.931-.247l2.262,2.2a2.116,2.116,0,0,1,.647-.648Zm-2.6-1.032a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1-248.048,238.411Z",
    transform: "translate(-1.456 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-244.887,248.158a2.114,2.114,0,0,1,.647.647l2.262-2.2a1.855,1.855,0,0,0,.931.247,1.9,1.9,0,0,0,1.906-1.906,1.9,1.9,0,0,0-1.906-1.9,1.9,1.9,0,0,0-1.906,1.9,1.818,1.818,0,0,0,.313,1.033Zm3.84-2.2a1,1,0,0,1-1-1,1,1,0,0,1,1-1,1.006,1.006,0,0,1,1,1A1.006,1.006,0,0,1-241.047,245.955Z",
    transform: "translate(-2.358 -1.454)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-249.185,249.917a1.817,1.817,0,0,0-.313,1.032,1.9,1.9,0,0,0,1.906,1.906,1.9,1.9,0,0,0,1.906-1.906,1.9,1.9,0,0,0-1.906-1.906,1.861,1.861,0,0,0-.931.247l-2.262-2.2a2.116,2.116,0,0,1-.647.648Zm2.6,1.032a1.006,1.006,0,0,1-1,1,1.006,1.006,0,0,1-1-1,1.006,1.006,0,0,1,1-1A1.006,1.006,0,0,1-246.589,250.949Z",
    transform: "translate(-0.904 -2.353)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-249.755,241.2a2.105,2.105,0,0,1-.647-.647l-2.262,2.2a1.855,1.855,0,0,0-.931-.247A1.9,1.9,0,0,0-255.5,244.4a1.9,1.9,0,0,0,1.906,1.906,1.9,1.9,0,0,0,1.906-1.906,1.82,1.82,0,0,0-.313-1.033Zm-3.84,2.2a1,1,0,0,1,1,1,1,1,0,0,1-1,1,1,1,0,0,1-1-1A1.006,1.006,0,0,1-253.594,243.4Z",
    transform: "translate(0 -0.899)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroups2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/groups-2.c4229434f81a69538edac1fa654aeb3c.svg";